import type { User, UserOriginNetwork, YammerState } from '../../state/types';

type GetUserOriginNetworkBadge = (state: YammerState, userId: User['id']) => string | undefined;
export const getUserOriginNetworkBadge: GetUserOriginNetworkBadge = (state, userId) =>
  state.userOriginNetworks?.fulfilled?.byId[userId]?.badge;

type GetUserOriginNetworkId = (state: YammerState, userId: User['id']) => string | undefined;
export const getUserOriginNetworkId: GetUserOriginNetworkId = (state, userId) =>
  state.userOriginNetworks?.fulfilled?.byId[userId]?.originNetworkId;

type GetFulfilledUsersOriginNetwork = (state: YammerState) => Record<string, UserOriginNetwork>;
/**
 * @deprecated PERFORMANCE This selects an object containing all fulfilled entities, which will return a new object
 * instance and force re-renders when ANY of the reducer's entities change in the store. This selector should be deleted.
 */
export const getFulfilledUsersOriginNetwork: GetFulfilledUsersOriginNetwork = (state) =>
  state.userOriginNetworks?.fulfilled?.byId;
